<template>
  <v-layout row justify-center>
    <v-dialog v-model="dialog" persistent max-width="380">
      <v-card>
        <v-toolbar dense  dark color="primary">
          <v-toolbar-title>{{$t("view.ejecucion.title")}}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon dark @click.native="dialog = false">
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <v-list dense two-line subheader >
            <!-- <v-subheader></v-subheader> -->
            <v-list-tile >
              <v-list-tile-content>
                <!-- <v-layout row>
                  <v-flex md12> -->
                    
                  <!-- </v-flex>
                </v-layout> -->
                <v-list-tile-title>{{$t("view.comercio.title")}}</v-list-tile-title>
                <v-list-tile-action>
                  <v-autocomplete
                    :max-height="200" 
                    v-model="$v.ejecucion.comerciosId.$model"
                    :items="view.elem.select.comercio"
                    :loading="isLoading"
                    :search-input.sync="search"
                    hide-no-data
                    hide-selected
                    multiple
                    clearable
                    deletable-chips 
                    chips
                    dense
                    item-text="name"
                    item-value="code"
                    :error-messages="getFirstErrorDescription($v.ejecucion.comerciosId)"
                    append-icon="mdi-database-search">
                  </v-autocomplete>
                </v-list-tile-action>
              </v-list-tile-content>
            </v-list-tile>
            <!-- <v-subheader></v-subheader> -->
          </v-list>
          <v-divider/>
          <v-list dense two-line subheader>
            <v-list-tile >
              <v-list-tile-content >
                <v-list-tile-title>{{$t('view.seguimientoControl.tipoEjecucion')}}</v-list-tile-title>
                <v-list-tile-action>
                  <v-autocomplete
                    v-model="$v.ejecucion.tipoEjecucion.$model"
                    :items="view.elem.select.ejecucion"
                    hide-no-data
                    hide-selected
                    dense
                    chips
                    clearable
                    :error-messages="getFirstErrorDescription($v.ejecucion.tipoEjecucion)"
                    item-text="name"
                    item-value="code"
                  ></v-autocomplete>
                </v-list-tile-action>
              </v-list-tile-content>
            </v-list-tile>
          </v-list>
          <v-divider/>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn :disabled="view.action.submit.busy" :loading="view.action.submit.busy" color="green" flat @click="submit()">{{$t("view.global.common.aplicar")}}</v-btn>
        </v-card-actions>
        
      </v-card>
    </v-dialog>
  </v-layout>
</template>
<script>
import CombosAPI from "@/services/catalogos";
import {EjecucionExtemporaneaModel} from "@/models/seguimiento/scheduled/ejecucion-extemporanea";
import {modelIsModified} from "@/helpers/vue-mc";
import {required, maxLength,email,numeric} from "vuelidate/lib/validators";
import {allValidatorMethods} from "@/helpers/vuelidate";
import SeguimientoAPI from "@/services/seguimiento/scheduled";
import {getErrors,getBusinessCode,getResponseDTO,handleResponseMessage} from '@/helpers/http-response-handler';
export default {
  data() {
    name: "SeguimientoControlScheduled"
    return {
      dialog : false
      , locale : this.$store.language
      , detalleBitacora : {}
      , comercios:[]
      , ejecucion: undefined
      , isLoading:false
      , search:''
      , tipoEjecucion:{}
      , view:{
        elem:{
          select: {
            comercio:[]
            , ejecucion:[{code: 'PETICION', name :"Petición"},{code:'RESPUESTA', name:'Respuesta'}]
          }
        }
        , action:{
          submit:{
            busy: false
          }
        }
        
      }
    }
  }
  , methods:{
    ...allValidatorMethods
    , async openModal(){
      try{
        this.dialog = true;
        const responseCombosComerciosActive = await CombosAPI.get({tipo:'comerciosActivos'});
        this.view.elem.select.comercio = responseCombosComerciosActive.data.results.combo;
      }catch(error){
        console.log(error);
      }
      
    }
    , resetModel(){
      this.ejecucion = new BitacoraArchivoModel();
    }
    , resetValidators(){
      this.$v.$reset();
    }
    , isDisableButtonSubmit(){
      return this.hasErrors(this.$v.ejecucion) 
        || this.view.action.submit.busy
        || !modelIsModified(this.ejecucion)
    }
    , async submit(){
      try{
        if(!this.isAllValid(this.$v))
          return
        this.view.action.submit.busy = true;
        const respuesta = await SeguimientoAPI.post(this.ejecucion)
        const responseDTO = getResponseDTO(respuesta);
        handleResponseMessage({response: respuesta,modulo:this.name})
        this.resetValidators();
        this.dialog = false;
      }catch(error){
        console.error(error)
      }finally{
        this.view.action.submit.busy = false;
      }
    }
  }
  , validations:{
    ejecucion:{
      comerciosId : {
        required
      }
      , tipoEjecucion : {
        required
      }
    }
  }
  , created(){
    this.ejecucion = new EjecucionExtemporaneaModel()
  }
  
}
</script>



// WEBPACK FOOTER //
// src/views/seguimiento/scheduled/EjecucionExtemporanea.vue